import PROJECT_CONFIG from '../project_config'

export const handleContentDetailResponse = (res, res1) => {
  const data = {}
  // 作者
  data.author = res.data.author
  // 标题
  data.title = res.data.title
  // 摘要
  data.summary = res.data.summary
  // 内容
  data.content = res.data.content
  // 评论数
  data.commentNum = res.data.commentnum
  // 已读数
  data.readedNum = res.data.readednum
  // 点赞数
  data.likedNum = res.data.likednum
  // 收藏数
  data.favoriteNum = res.data.favoritenum
  // 是否已点赞文章
  data.hasClicked = res1 && res1.data && res1.data.likeClickByUser
  // 是否已收藏文章
  data.hasFavorite = res1 && res1.data && res1.data.saveByUser
  // 封面
  data.coverImg = res.data.coverImg
  // 创建时间
  data.createDataTime = res.data.createTime
  // 创建人
  data.createDataUsername = res.data.createUsername
  // 内容类型
  data.msgType = res.data.msgType
  // 分享范围
  data.shareRange = res.data.shareRange
  // 评论设置 -- 1 先发后审  2 先审后发
  data.commentType = res.data.commentType
  // 服务号id
  data.sid = res.data.sid
  // 服务号名称
  data.sName = res.data.sName
  // 是否有up主
  data.hasUP = res.data.sName !== null
  // 文章视频
  data.videoUrl = res.data.extras && JSON.parse(res.data.extras) && JSON.parse(res.data.extras).url
  // 文章视频封面图
  data.videoUrlCover = res.data.extras && JSON.parse(res.data.extras) && JSON.parse(res.data.extras).cover
  // jumpurl(预留字段)
  if (res.data.msgType === 2) {
    data.jumpurl = res.data.contentUrl
    res.code = 30003
  }
  // 素材id
  data.materialId = res.data.materialId
  // 素材标签
  if (Array.isArray(res.data.tags)) {
    data.tags = res.data.tags.map(item => {
      item.jump_url = PROJECT_CONFIG.externalUrl + `tags/detail/${item.id}?name=${encodeURIComponent(item.name)}`
      return item
    })
  } else {
    data.tags = res.data.tags
  }
  // 跳转up主详情
  data.up_url = PROJECT_CONFIG.externalUrl + `up/${res.data.sid}`
  const _data = {}
  _data.data = {}
  _data.data.code = res.code
  _data.data.data = data
  _data.data.msg = res.msg
  return _data
}
